import { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { apiClient } from "utils/clients.ts";

let volumeViewScanTriggered = false;

export const useVolumeViewScanOnLoad = () => {
    const accountId = useSelector((state: RootState) => state.tenancy.selectedAccountId);

    useEffect(() => {
        if (!accountId || volumeViewScanTriggered) {
            return;
        }

        volumeViewScanTriggered = true;

        apiClient
            .post(`${import.meta.env.VITE_WLM_BACKEND_URL}/accounts/${accountId}/volume-view/v1/scan`, {})
            .catch((error) => {
                console.error("Failed to trigger volume-view scan on load", error);
            });
    }, [accountId]);
};
